import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2" }
const _hoisted_2 = { class: "d-flex align-items-center gap-3" }
const _hoisted_3 = {
  class: "text-white mb-0",
  style: {"font-weight":"800"}
}
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "border-style" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "border-style" }
const _hoisted_9 = {
  key: 0,
  class: "text-silver"
}
const _hoisted_10 = {
  key: 1,
  class: "editor-layout"
}
const _hoisted_11 = { class: "editor-main" }
const _hoisted_12 = { class: "editor-field" }
const _hoisted_13 = { class: "editor-field" }
const _hoisted_14 = { class: "editor-field" }
const _hoisted_15 = { class: "editor-field" }
const _hoisted_16 = { class: "editor-tabs" }
const _hoisted_17 = { class: "html-toolbar" }
const _hoisted_18 = { class: "url-prompt-bar" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "url-prompt-error"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "editor-sidebar" }
const _hoisted_23 = { class: "sidebar-card" }
const _hoisted_24 = {
  key: 0,
  class: "cover-preview"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "editor-field mt-2" }
const _hoisted_27 = { class: "sidebar-card" }
const _hoisted_28 = { class: "editor-field" }
const _hoisted_29 = { class: "editor-field" }
const _hoisted_30 = { class: "editor-field" }
const _hoisted_31 = { class: "sidebar-card" }
const _hoisted_32 = { class: "status-display" }
const _hoisted_33 = {
  key: 2,
  class: "save-error mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: "/admin/blog",
            class: "back-btn"
          }, {
            default: _withCtx(() => _cache[32] || (_cache[32] = [
              _createElementVNode("i", { class: "ti ti-arrow-left" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.isNew ? 'New Post' : 'Edit Post'), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn",
            disabled: _ctx.saving,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save('draft')))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.saving === 'draft' ? 'Saving...' : 'Save Draft'), 1)
          ], 8, _hoisted_5),
          _createElementVNode("button", {
            class: "btn btn-publish",
            disabled: _ctx.saving,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save('published')))
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.saving === 'published' ? 'Publishing...' : 'Publish'), 1)
          ], 8, _hoisted_7)
        ])
      ]),
      (_ctx.fetchLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Loading post..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[33] || (_cache[33] = _createElementVNode("label", null, "Title *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                  class: "editor-input",
                  placeholder: "Enter post title...",
                  onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.autoSlug && _ctx.autoSlug(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.form.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[34] || (_cache[34] = _createElementVNode("label", null, "Slug", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.slug) = $event)),
                  class: "editor-input slug-input",
                  placeholder: "post-url-slug"
                }, null, 512), [
                  [_vModelText, _ctx.form.slug]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[35] || (_cache[35] = _createElementVNode("label", null, [
                  _createTextVNode("Excerpt "),
                  _createElementVNode("span", { class: "label-hint" }, "— short summary shown on listing page")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.excerpt) = $event)),
                  class: "editor-input",
                  rows: "2",
                  placeholder: "Brief description of the post..."
                }, null, 512), [
                  [_vModelText, _ctx.form.excerpt]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: _normalizeClass(['tab-btn', { active: _ctx.activeTab === 'html' }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = 'html'))
                  }, _cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "ti ti-code" }, null, -1),
                    _createTextVNode(" HTML Source ")
                  ]), 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(['tab-btn', { active: _ctx.activeTab === 'preview' }]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeTab = 'preview'))
                  }, _cache[37] || (_cache[37] = [
                    _createElementVNode("i", { class: "ti ti-eye" }, null, -1),
                    _createTextVNode(" Preview ")
                  ]), 2)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Bold",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.insertTag('strong')))
                  }, _cache[38] || (_cache[38] = [
                    _createElementVNode("b", null, "B", -1)
                  ])),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Italic",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.insertTag('em')))
                  }, _cache[39] || (_cache[39] = [
                    _createElementVNode("i", null, "I", -1)
                  ])),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Heading 2",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.insertBlock('h2')))
                  }, "H2"),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Heading 3",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.insertBlock('h3')))
                  }, "H3"),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Paragraph",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.insertBlock('p')))
                  }, "P"),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Bullet list",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.insertList()))
                  }, _cache[40] || (_cache[40] = [
                    _createElementVNode("i", { class: "ti ti-list" }, null, -1)
                  ])),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Blockquote",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.insertBlock('blockquote')))
                  }, "\""),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Link",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.insertLink()))
                  }, _cache[41] || (_cache[41] = [
                    _createElementVNode("i", { class: "ti ti-link" }, null, -1)
                  ])),
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "tool-sep" }, null, -1)),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Upload & insert image",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.triggerImageUpload()))
                  }, [
                    _cache[42] || (_cache[42] = _createElementVNode("i", { class: "ti ti-photo" }, null, -1)),
                    _cache[43] || (_cache[43] = _createTextVNode(" Image ")),
                    _createElementVNode("input", {
                      ref: "imageInput",
                      type: "file",
                      accept: "image/*",
                      style: {"display":"none"},
                      onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onImageUpload && _ctx.onImageUpload(...args)))
                    }, null, 544)
                  ]),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    title: "Embed YouTube video",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.insertVideo()))
                  }, _cache[44] || (_cache[44] = [
                    _createElementVNode("i", { class: "ti ti-brand-youtube" }, null, -1),
                    _createTextVNode(" Video ")
                  ]))
                ], 512), [
                  [_vShow, _ctx.activeTab === 'html']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_18, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.urlPrompt.mode === 'video' ? 'ti ti-brand-youtube' : 'ti ti-link')
                  }, null, 2),
                  _withDirectives(_createElementVNode("input", {
                    ref: "urlPromptInput",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.urlPrompt.value) = $event)),
                    class: "editor-input",
                    placeholder: _ctx.urlPrompt.mode === 'video' ? 'https://www.youtube.com/watch?v=...' : 'https://...',
                    onKeydown: [
                      _cache[20] || (_cache[20] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmUrlPrompt && _ctx.confirmUrlPrompt(...args)), ["prevent"]), ["enter"])),
                      _cache[21] || (_cache[21] = _withKeys(($event: any) => (_ctx.urlPrompt.open = false), ["esc"]))
                    ]
                  }, null, 40, _hoisted_19), [
                    [_vModelText, _ctx.urlPrompt.value]
                  ]),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.confirmUrlPrompt && _ctx.confirmUrlPrompt(...args)))
                  }, "Insert"),
                  _createElementVNode("button", {
                    class: "tool-btn",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.urlPrompt.open = false))
                  }, "Cancel"),
                  (_ctx.urlPrompt.error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.urlPrompt.error), 1))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _ctx.activeTab === 'html' && _ctx.urlPrompt.open]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  ref: "contentArea",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.content) = $event)),
                  class: "editor-input content-area",
                  rows: "24",
                  placeholder: "Paste HTML content here, or type and use the toolbar above...",
                  spellcheck: "false"
                }, null, 512), [
                  [_vShow, _ctx.activeTab === 'html'],
                  [_vModelText, _ctx.form.content]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "blog-content content-preview",
                  innerHTML: _ctx.renderedPreview
                }, null, 8, _hoisted_21), [
                  [_vShow, _ctx.activeTab === 'preview']
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[49] || (_cache[49] = _createElementVNode("h5", { class: "sidebar-card-title" }, "Cover Image", -1)),
                (_ctx.form.cover_image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("img", {
                        src: _ctx.form.cover_image,
                        alt: "cover"
                      }, null, 8, _hoisted_25),
                      _createElementVNode("button", {
                        class: "remove-cover",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.cover_image = ''))
                      }, _cache[46] || (_cache[46] = [
                        _createElementVNode("i", { class: "ti ti-x" }, null, -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "upload-btn",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.triggerCoverUpload()))
                }, [
                  _cache[47] || (_cache[47] = _createElementVNode("i", { class: "ti ti-upload" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.coverUploading ? 'Uploading...' : 'Upload Cover Image') + " ", 1),
                  _createElementVNode("input", {
                    ref: "coverInput",
                    type: "file",
                    accept: "image/*",
                    style: {"display":"none"},
                    onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onCoverUpload && _ctx.onCoverUpload(...args)))
                  }, null, 544)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[48] || (_cache[48] = _createElementVNode("label", null, "Or enter image URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.cover_image) = $event)),
                    class: "editor-input",
                    placeholder: "https://..."
                  }, null, 512), [
                    [_vModelText, _ctx.form.cover_image]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "sidebar-card-title" }, "SEO", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _cache[50] || (_cache[50] = _createElementVNode("label", null, "Meta Title", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.meta_title) = $event)),
                    class: "editor-input",
                    placeholder: "Page title for Google..."
                  }, null, 512), [
                    [_vModelText, _ctx.form.meta_title]
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["char-count", { warn: (_ctx.form.meta_title || '').length > 60 }])
                  }, _toDisplayString((_ctx.form.meta_title || '').length) + "/60 ", 3)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[51] || (_cache[51] = _createElementVNode("label", null, "Meta Description", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.meta_description) = $event)),
                    class: "editor-input",
                    rows: "3",
                    placeholder: "Description shown in search results..."
                  }, null, 512), [
                    [_vModelText, _ctx.form.meta_description]
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["char-count", { warn: (_ctx.form.meta_description || '').length > 160 }])
                  }, _toDisplayString((_ctx.form.meta_description || '').length) + "/160 ", 3)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[52] || (_cache[52] = _createElementVNode("label", null, "Keywords", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.meta_keywords) = $event)),
                    class: "editor-input",
                    placeholder: "keyword1, keyword2, ..."
                  }, null, 512), [
                    [_vModelText, _ctx.form.meta_keywords]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[54] || (_cache[54] = _createElementVNode("h5", { class: "sidebar-card-title" }, "Status", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['status-badge', _ctx.form.status])
                  }, _toDisplayString(_ctx.form.status), 3)
                ])
              ])
            ])
          ])),
      (_ctx.saveError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.saveError), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}